import { useState } from "react";
import { canvasPanelClassNames } from "./canvasTheme";
import { EntitiesSettingsPage } from "./settings-panel/EntitiesSettingsPage";
import { GeneralSettingsPage } from "./settings-panel/GeneralSettingsPage";
import { TabButton } from "./settings-panel/SettingsPanelFields";
import { ShortcutsSettingsPage } from "./settings-panel/ShortcutsSettingsPage";
import { UnitsSettingsPage } from "./settings-panel/UnitsSettingsPage";
import type { SettingsPage, SettingsPanelProps } from "./settingsPanelTypes";

export function SettingsPanel(props: SettingsPanelProps) {
  const [activePage, setActivePage] = useState<SettingsPage>("general");

  if (!props.isOpen) return null;

  return (
    <aside
      className={canvasPanelClassNames.panel}
      style={props.panelStyle}
      onMouseDownCapture={props.onActivate}
      onFocusCapture={props.onActivate}
    >
      <div className={canvasPanelClassNames.panelHeader}>
        <h3 className={canvasPanelClassNames.panelTitle}>Settings</h3>
        <button
          type="button"
          className={canvasPanelClassNames.iconButton}
          aria-label="Close settings"
          title="Close settings"
          onClick={props.onClose}
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" className="h-[14px] w-[14px] fill-current">
            <path d="M4 7h16v2H4V7Zm0 5h16v2H4v-2Zm0 5h16v2H4v-2Z" />
          </svg>
        </button>
      </div>

      <div className={canvasPanelClassNames.tabList}>
        <TabButton page="units" activePage={activePage} onClick={setActivePage}>
          Units
        </TabButton>
        <TabButton page="general" activePage={activePage} onClick={setActivePage}>
          General
        </TabButton>
        <TabButton page="entities" activePage={activePage} onClick={setActivePage}>
          Objects
        </TabButton>
        <TabButton page="shortcuts" activePage={activePage} onClick={setActivePage}>
          Keyboard
        </TabButton>
      </div>

      {activePage === "units" && <UnitsSettingsPage {...props} />}
      {activePage === "general" && <GeneralSettingsPage {...props} />}
      {activePage === "entities" && <EntitiesSettingsPage {...props} />}
      {activePage === "shortcuts" && <ShortcutsSettingsPage {...props} />}
    </aside>
  );
}
